module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots.groups')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionSlotTemplates), function(missionSlotTemplate) {
    return _c('mission-slot-template-list-row', {
      key: missionSlotTemplate.uid,
      attrs: {
        "missionSlotTemplate": missionSlotTemplate
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplates.length >= 10),
      expression: "missionSlotTemplates.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots.groups')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21170510"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateListTable.vue
// module id = 486
// module chunks = 0